import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { OidcAuth } from "@csa/web-foundation";
import { App } from "./App";
import "./styles.css";

// The OidcAuth is realm-agnostic — configured for the csa-customer realm via
// AppConfig (VITE_OIDC_* env), no code fork. Passkey/phone-OTP are realm-side (CR1);
// the app just runs the standard OIDC/PKCE flow.
const auth = new OidcAuth();
const root = document.getElementById("root");
if (!root) throw new Error("root element missing");
createRoot(root).render(
  <StrictMode>
    <App auth={auth} />
  </StrictMode>,
);
